import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function MultiCharge() {
    const { useState, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const [isEnter, setIsEnter] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.multiChargeAnime`,
            offset: -200, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setIsEnter(true);
        });
        sceneA1.on('leave', function () {
            setIsEnter(false);
        });
        // @ts-ignore
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div
            className={`${css.multiCharge} multiChargeAnime GtmModuleData-section`}
            data-section-id={css.multiCharge}
            data-section-title={t('delta2.aniG_msg1')}
        >
            <div className="img-bg">
                <EFPic name={['star.webp', 'star.png']} />
            </div>
            <div className="text-content">
                <div className="title-content">
                    <p className="subTitle">{t('delta2.aniG_msg1')}</p>
                    <div className="title">
                        <span className="line1">{t('delta2.aniG_msg2')}</span>
                        <span className="line2">{t('delta2.aniG_msg3')}</span>
                        <span className="line3">{t('delta2.aniG_msg4')}</span>
                    </div>
                    <div className="desc">{t('delta2.aniG_msg5')}</div>
                </div>
                <div className="multi_charge_content">
                    <div className={`content ${isEnter ? 'isEnter' : ''}`}>
                        <div className="delta2">
                            <div className="progress_bar">
                                <div className="left">
                                    <h6 className="name">{t('delta2.aniG_msg7')}</h6>
                                    <div className="charge" style={locale === 'fr' ? { width: '1.1rem' } : {}}>
                                        {t.rich('delta2.aniG_msg8', {
                                            line1: (text: string) => (
                                                <Link className="ef-link__page is-mobile" href="/x-stream" newWin>
                                                    {text}
                                                </Link>
                                            ),
                                        })}
                                    </div>
                                </div>
                                <div className="right time">
                                    <span className="hrs">50</span>
                                    <span className="unit">{t('delta2.aniG_msg13')}</span>
                                </div>
                            </div>
                            <div className="delta2-text">
                                <div className="text1">{t('delta2.aniG_num2')}</div>
                                <div className="text2">{t('delta2.aniG_msg9')}</div>
                            </div>
                        </div>
                        <div className="other">
                            <div className="progress_bar">
                                <div className="left">
                                    <h6 className="name">{t('delta2.aniG_msg10')}</h6>
                                    <div className="charge">{t('delta2.aniG_msg12')}</div>
                                </div>
                                <div className="right time">
                                    <span className="hrs">{t('delta2.aniG_num3')}</span>
                                    <span className="unit">{t('delta2.aniG_msg11')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p className="note">{t('delta2.aniG_msg6')}</p>
            </div>
        </div>
    );
}
